import {
  Avatar,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
} from "@mui/material";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  classes: any;
  open: boolean;
  handleClose: any;
}

export default function ProfileModal({ classes, open, handleClose }: Props) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: "6px" } }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ p: "1.5rem 1.5rem 0.5rem 1.5rem", fontWeight: "bold" }}
        >
          My Profile
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ p: "1.5rem" }}>
          <DialogContentText id="alert-dialog-description">
            <div className={classes.profileModal}>
              <div className={classes.leftprofile}>
                <Avatar alt="" src="" style={{ height: "40px", width: "40px" }}>
                  F
                </Avatar>{" "}
                <div className={classes.userDetails}>
                  <div className={classes.username}>Chethan K</div>
                  <div className={classes.username}>KC1593</div>
                  {/* <div className={classes.userEmail}>k.chethan222@gmail.com</div>
                  <div className={classes.userAddress}>9666318914</div> */}
                </div>
              </div>
            </div>
            {/* <Divider /> */}
            <div className={classes.profileModalTop}>
              <div
                className={classes.leftprofile}
                style={{
                  textAlign: "center",
                  background: "#cadbf3",
                  borderRadius: "10px",
                  color: "black",
                  margin: "10px 0",
                }}
              >
                Personel Information
              </div>
              <p className={classes.title}>
                Phone
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className={classes.content}> : 9666318914</span>
              </p>
              <p className={classes.title}>
                Email{" "}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className={classes.content}>
                  {" "}
                  : k.chethan222@gmail.com
                </span>
              </p>
              <p className={classes.title}>
                Pan No
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className={classes.content}> : BSJPE2707L</span>
              </p>
              <p className={classes.title}>
                GSTN No{" "}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className={classes.content}> : 29AAAAVBUY3708C</span>
              </p>
              <p className={classes.title}>
                Address 1{" "}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className={classes.content}>
                  {" "}
                  : No.2, New School Road, Jayanagar 4th Block
                </span>
              </p>
              <p className={classes.title}>
                Address 2{" "}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className={classes.content}>
                  {" "}
                  : No.2, New School Road, Jayanagar 4th Block
                </span>
              </p>
              <p className={classes.title}>
                Pin Code
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className={classes.content}> : 560073</span>
              </p>
              <p className={classes.title}>
                City
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className={classes.content}> : Bangalore</span>
              </p>
              <p className={classes.title}>
                State
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                <span className={classes.content}> : Karnataka</span>
              </p>

              {/* <Divider /> */}
              <div
                className={classes.leftprofile}
                style={{
                  textAlign: "center",
                  background: "#cadbf3",
                  borderRadius: "10px",
                  color: "black",
                  margin: "10px 0",
                }}
              >
                Bank Details
              </div>
              <p className={classes.title}>
                Bank Name
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                <span className={classes.content}> : HDFC</span>
              </p>
              <p className={classes.title}>
                Bank Branch Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                <span className={classes.content}> : Jayanagar</span>
              </p>
              <p className={classes.title}>
                IFSC&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className={classes.content}> : HDFC0000261</span>
              </p>
              <p className={classes.title}>
                Bank A/C Type
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className={classes.content}> : Current</span>
              </p>
              <p className={classes.title}>
                Bank Account No &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                <span className={classes.content}> : 5600731245768</span>
              </p>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
